import { sanitizeRichHtml, sanitizeRuntimeHtml } from './sanitizeRichHtml'

export type SafeInnerHtml = {
  __html: string
}

const toSafeJsonString = (value: unknown): string => {
  try {
    return JSON.stringify(value ?? null)
  } catch {
    return 'null'
  }
}

export const serializeJsonForScriptTag = (value: unknown): string =>
  toSafeJsonString(value)
    .replace(/</g, '\\u003C')
    .replace(/>/g, '\\u003E')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')

export const toSafeHtml = (value: unknown): SafeInnerHtml => ({
  __html: sanitizeRichHtml(value),
})

export const toSafeRuntimeHtml = (value: unknown): SafeInnerHtml => ({
  __html: sanitizeRuntimeHtml(value),
})

export const toSafeJsonScript = (value: unknown): SafeInnerHtml => ({
  __html: serializeJsonForScriptTag(value),
})
